module.exports = __webpack_public_path__ + "static/img/Sota.ed9836a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/partners/nets/Sota.png
// module id = KFGG
// module chunks = 0